/**
 * What a phone field accepts before normalisation: digits with spaces, dashes,
 * dots, or parentheses, optionally led by "+". Shared by the gateway schema
 * and the widget's lead form (via the dependency-free "./whatsapp" subpath).
 */
export const PHONE_PATTERN = /^\+?[0-9\s().-]{8,24}$/;

/**
 * Phone numbers arrive in every shape. Indonesian ones dominate ("0812-3456-7890",
 * "+62 812…", "62812…", "812…") but exporters' buyers write from abroad
 * ("+49 40 1234 5678"). wa.me wants the bare international form without "+".
 *
 * - A leading "0" or a bare "8…" is Indonesian shorthand → 62…
 * - Anything else is taken as already international (E.164: 8–15 digits,
 *   never starting with 0); Indonesian numbers keep their stricter length.
 */
export function normalizeWhatsapp(input: string): string | null {
  const digits = input.replace(/[^0-9]/g, "");
  if (!digits) return null;
  const explicitInternational = input.trim().startsWith("+");
  const international = digits.startsWith("0") ? `62${digits.slice(1)}` : digits.startsWith("8") && !explicitInternational ? `62${digits}` : digits;
  if (international.startsWith("62")) return /^62\d{8,13}$/.test(international) ? international : null;
  return /^[1-9]\d{7,14}$/.test(international) ? international : null;
}

export function whatsappUrl(number: string | null | undefined, text?: string): string | null {
  const normalized = number ? normalizeWhatsapp(number) : null;
  if (!normalized) return null;
  return text ? `https://wa.me/${normalized}?text=${encodeURIComponent(text)}` : `https://wa.me/${normalized}`;
}
